import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import ModalHeader from '../../../UniformComponents/ModalHeader'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'
import Input from '../../form/Input'

@observer
class DashboardClone extends Component {
    constructor(props) {
        super(props)

        const { dashStore } = props
        const { dashboard } = dashStore

        this.state = {
            name: `${dashboard.name} (copy)`,
        }
    }

    render() {
        const {
            show, onClose, dashStore,
        } = this.props
        const { name } = this.state
        const { saveDashboard } = dashStore

        return (
            <Modal show={show} onClose={onClose}>
                <ModalHeader>
                    <h2 style={{ width: '100%', textAlign: 'center' }}>{i18n.t('dashboard.modal.clone.title')}</h2>
                </ModalHeader>
                <div style={{
                    width: '100%', textAlign: 'center', fontWeight: 500, fontSize: '18px',
                }}
                >
                    <Input
                        label={i18n.t('dashboard.modal.clone.label')}
                        value={name}
                        onChange={({ value }) => { this.setState({ name: value }) }}
                    />
                </div>
                <ModalFooter>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                        <Button
                            style={{
                                background: '#FE5A8C',
                                boxShadow: 'unset',
                            }}
                            onClick={onClose}
                        >
                            {i18n.t('cancel')}
                        </Button>
                        <Button
                            style={{
                                boxShadow: 'unset',
                            }}
                            onClick={() => {
                                onClose()
                                saveDashboard(true, name)
                            }}
                        >
                            {i18n.t('save')}
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

export default DashboardClone
